import PageShell from "@/components/site/PageShell";
import Hero from "@/components/home/Hero";
import AboutResort from "@/components/home/AboutResort";
import RoomsGrid from "@/components/home/RoomsGrid";
import FeatureSection from "@/components/site/FeatureSection";
import ReviewsSlider from "@/components/site/ReviewsSlider";
import GamesSection from "@/components/site/GamesSection";
import NearbyFastSlider from "@/components/site/NearbyFastSlider";
import BookingForm from "@/components/site/BookingForm";
import InstagramGallery from "@/components/home/InstagramGallery";
import LegacyContent from "@/components/site/LegacyContent";
import BookingCTA from "@/components/home/BookingCTA";
import { FOOD, POOL, CAMPFIRE } from "@/data/content";

export default function Home() {
  return (
    <PageShell testId="home-page">
      <Hero />
      <AboutResort />
      <RoomsGrid />
      <FeatureSection
        testId="home-pool"
        overline="Unwind · Infinity Pool"
        title="Swim at the edge of the valley"
        intro={`${POOL.intro} ${POOL.couplesFamilies}`}
        images={POOL.images}
        dark
        cta={{ label: "See the pool", to: "/experiences/pool" }}
      />
      <FeatureSection
        testId="home-food"
        overline="Taste · Malnad Kitchen"
        title="Authentic Malnad food, cooked slow"
        intro={FOOD.intro}
        images={FOOD.images}
        list={FOOD.dishes}
        reverse
        cta={{ label: "Explore the food", to: "/experiences/food" }}
      />
      <FeatureSection
        testId="home-campfire"
        overline="Evenings · Bonfire"
        title="Gather around the fire under the stars"
        intro={CAMPFIRE.intro}
        images={CAMPFIRE.images}
        dark
        cta={{ label: "Campfire nights", to: "/experiences/campfire" }}
      />
      <GamesSection />
      <ReviewsSlider />
      <LegacyContent testId="home-legacy" />
      <NearbyFastSlider />
      <BookingForm />
      <InstagramGallery />
      <BookingCTA />
    </PageShell>
  );
}
